// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GoogleStore$PorterinFeature from "../../../../../../shared/geocode/domain/store/GoogleStore.mjs";

var pickup_pin_icon = {
  src: GoogleStore$PorterinFeature.pickup_pin_icon_url,
  width: 16.0,
  height: 16.0,
  alt: GoogleStore$PorterinFeature.pickup_pin_icon_alt
};

var pickup_pin_tool_tip = {
  src: GoogleStore$PorterinFeature.pickup_pin_tool_tip_url,
  width: 16.0,
  height: 16.0,
  alt: GoogleStore$PorterinFeature.pickup_pin_tool_tip_url
};

var drop_pin_tool_tip = {
  src: GoogleStore$PorterinFeature.drop_pin_tool_tip_url,
  width: 16.0,
  height: 16.0,
  alt: GoogleStore$PorterinFeature.drop_pin_tool_tip_alt
};

var drop_pin_icon = {
  src: GoogleStore$PorterinFeature.drop_pin_icon_url,
  width: 16.0,
  height: 16.0,
  alt: GoogleStore$PorterinFeature.drop_pin_icon_alt
};

export {
  pickup_pin_icon ,
  pickup_pin_tool_tip ,
  drop_pin_tool_tip ,
  drop_pin_icon ,
}
/* No side effect */
